import React from 'react';
import { getMediaUrl } from '../utils/mediaUrl';

/**
 * OptimizedImage renders <picture> with WebP source when a webpSrc is explicitly
 * provided, otherwise renders a plain <img>. This avoids speculating about
 * WebP files that may not exist for older uploads.
 *
 * Props:
 *   src      – original image path (required)
 *   webpSrc  – explicit WebP path, e.g. from media.versions.large.webp_url
 *   alt, className, loading, style – forwarded to <img>
 */
const OptimizedImage = ({ src, webpSrc, alt, className, loading = 'lazy', style, ...props }) => {
  const resolvedSrc = getMediaUrl(src);
  const resolvedWebp = webpSrc ? getMediaUrl(webpSrc) : '';

  if (!resolvedSrc) return null;

  if (resolvedWebp) {
    return (
      <picture>
        <source srcSet={resolvedWebp} type="image/webp" />
        <img
          src={resolvedSrc}
          alt={alt || ''}
          className={className}
          loading={loading}
          style={style}
          {...props}
        />
      </picture>
    );
  }

  return (
    <img
      src={resolvedSrc}
      alt={alt || ''}
      className={className}
      loading={loading}
      style={style}
      {...props}
    />
  );
};

export default OptimizedImage;
